var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShootingBrake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4123 24.8379C12.4335 24.8379 13.2614 24.01 13.2614 22.9887C13.2614 21.9675 12.4335 21.1396 11.4123 21.1396C10.391 21.1396 9.56311 21.9675 9.56311 22.9887C9.56311 24.01 10.391 24.8379 11.4123 24.8379ZM11.4123 25.712C12.9163 25.712 14.1356 24.4928 14.1356 22.9887C14.1356 21.4847 12.9163 20.2654 11.4123 20.2654C9.90823 20.2654 8.68896 21.4847 8.68896 22.9887C8.68896 24.4928 9.90823 25.712 11.4123 25.712Z",
    fill: "#BABABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5675 24.8379C30.5888 24.8379 31.4167 24.01 31.4167 22.9887C31.4167 21.9675 30.5888 21.1396 29.5675 21.1396C28.5463 21.1396 27.7184 21.9675 27.7184 22.9887C27.7184 24.01 28.5463 24.8379 29.5675 24.8379ZM29.5675 25.712C31.0716 25.712 32.2908 24.4928 32.2908 22.9887C32.2908 21.4847 31.0716 20.2654 29.5675 20.2654C28.0635 20.2654 26.8442 21.4847 26.8442 22.9887C26.8442 24.4928 28.0635 25.712 29.5675 25.712Z",
    fill: "#BABABA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4547 16.4663C15.9849 14.5499 19.7654 12.8168 33.2661 15.0542L31.7868 15.6594C33.4165 16.3505 34.2197 16.7748 34.8127 17.8111V18.9542C35.9558 20.5344 34.2075 22.0137 32.6273 22.2155C32.3289 20.7996 31.0724 19.7275 29.5677 19.7275C27.8859 19.7275 26.5114 21.0553 26.441 22.7198L14.5392 23.2241V22.8543C14.5392 21.1274 13.1393 19.7275 11.4124 19.7275C9.68554 19.7275 8.28565 21.1274 8.28565 22.8543V23.2241C7.73506 23.1942 7.17982 23.1707 6.65297 23.1483C5.2161 23.0874 3.99036 23.0355 3.64598 22.8879C3.17531 22.6862 3.20886 22.081 3.78045 21.812C3.62453 20.8741 3.61441 18.9735 3.64598 18.7525C3.6776 18.5311 3.88778 18.4287 3.96855 18.3894C3.97363 18.3869 3.9782 18.3847 3.98218 18.3827C7.27483 16.9955 9.04154 16.4975 12.4547 16.4663ZM23.2807 16.2981H29.467C27.9541 14.9197 27.0127 14.7516 22.9445 14.8188L23.2807 16.2981ZM16.0858 16.2981H22.0704L22.0031 14.8188C19.1707 14.8896 17.934 15.2712 16.0858 16.2981Z",
    fill: "#BABABA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShootingBrake);
export default ForwardRef;